export default __webpack_public_path__ + "static/media/nuclear_fuel_rod.88b3c7c8.png";